export default __webpack_public_path__ + "static/media/AuditorIcon.1688370f.png";